import React, { FC, useRef } from "react";
import type { HomeLatestInsightsProps } from "@/types";
import { Link } from "../link";
import { PostCard } from "../post-card";
import { useInView } from "@/hooks/reveal-in-view";
import { HomePostCard } from "../post-card-home";
import SplitTextAnimation from "../split-text-animation";

export const HomeLatestInsights: FC<HomeLatestInsightsProps> = ({
  title,
  viewAll,
  readMore,
  posts,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="homeLatestInsights">
      <div className="homeLatestInsights--inner">
        <div className="wrapper">
          <div className="homeLatestInsights--top">
          <h2 className="homeLatestInsights--title">Latest News at&nbsp;<span style={{ color: "#157BFA" }}>Payall</span></h2>
            {/* <SplitTextAnimation
              htmlElement={
                <h2 className="homeLatestInsights--title">Latest News at&nbsp;<span style={{ color: "#5ee8ff" }}>Payall</span></h2>
                // <h2 className="homeLatestInsights--title">{title}</h2>
              }
              isInView={isInView}
            /> */}
            {viewAll.link?.uri && (
              <Link
                href={viewAll.link?.uri}
                noStyle
                className="homeLatestInsights--viewAll"
              >
                {viewAll.text}
              </Link>
            )}
          </div>
          <div className="homeLatestInsights--cards" ref={ref}>
            {posts.map((post, index) => {
              return (
                <HomePostCard
                  key={index}
                  card={post}
                  readMore={readMore}
                  style={{
                    transform: isInView
                      ? "none"
                      : `translateY(${20 * (index + 1)}px)`,
                    opacity: isInView ? 1 : 0,
                    transition:
                      "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
